import React from 'react';
import Typography from '@mui/material/Typography';

export type JucyLightBoxTitleProps = { title?: string };
export const JucyLightBoxTitle = ({ title }: JucyLightBoxTitleProps) => {
    return title ? (
        <Typography
            sx={{
                fontWeight: '700',
                typography: 'subtitle2',
                color: 'text.primary',
                position: 'absolute',
                top: 0,
                left: 0,
                m: 1,
                p: 1,
                userSelect: 'none',
            }}
        >
            {title}
        </Typography>
    ) : null;
};
